var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RequestPermission",on:{"touchstart":function($event){_vm.onClick()},"click":function($event){_vm.onClick()}}},[_c('div',{staticClass:"RequestPermission__sentence"},[_vm._v(_vm._s(_vm.trans('sentence')))]),_vm._v(" "),_c('div',{staticClass:"Btn"},[_vm._v(_vm._s(_vm.trans('button')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d25a81a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/RequestPermission.vue
// module id = null
// module chunks = 